import React, { Component } from 'react';
import ReactDOM from "react-dom";
import { InfoWindow } from 'google-maps-react';


class InfoWindowElement extends Component {

    componentDidMount() {
        this.loadInfoWindowElement();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.activeMarker !== nextProps.activeMarker
            || this.props.infoWindowPosition !== nextProps.infoWindowPosition
            || this.props.showingInfoWindow !== nextProps.showingInfoWindow
            || this.props.selectedPlaceName !== nextProps.selectedPlaceName) {

            return true;
        }
        else {
            return false;
        }
    }

    componentDidUpdate() {
        this.loadInfoWindowElement();
    }

    onInfoWindowOpen() {
        ReactDOM.render(
            React.Children.only(this.props.selectedPlace),
            document.getElementById("infoWindowElement55")
        );
    }

    loadInfoWindowElement = () => {
        const infoWindowElement = <InfoWindow
            marker={this.props.activeMarker ? this.props.activeMarker : null}
            position={this.props.activeMarker == null ? this.props.infoWindowPosition : null}
            visible={this.props.showingInfoWindow}
            onOpen={e => {
                this.onInfoWindowOpen(this.props, e);
            }}

        >
            <div id="infoWindowElement55" />
        </InfoWindow>

        this.props.sendChildElementDataToState(this.props.stateElementName, infoWindowElement);

    }

    render() {
        return null
    }
}

export default InfoWindowElement;